import { Pipe, PipeTransform } from "@angular/core"

@Pipe({
    name: "langName",
})
export class langName {
    transform(i) {
        if (i == "cn") {
            return "体中文"
        }
        if (i == "th") {
            return "ไทย"
        }
        if (i == "en") {
            return "English"
        }
        if (i == "id") {
            return "Indonesia"
        }
        if (i == "vn") {
            return "Tiếng Việt"
        }
        if (i == "kh") {
            return "ភាសាខ្មែរ"
        }
        if (i == "la") {
            return "ລາວ"
        }
        if (i == "my") {
            return "Malaysia"
        }
        if (i == "mm") {
            return "မြန်မာ"
        }
        if (i == "ph") {
            return "Pilipinas"
        }
        if (i == "ko") {
            return "한국인"
        }
    }
}

@Pipe({
    name: "monthName",
})
export class monthName {
    transform(i) {
        if (i == "January") {
            return "体中文"
        }
        if (i == "February") {
            return "ไทย"
        }
        if (i == "March") {
            return "English"
        }
        if (i == "April") {
            return "Indonesia"
        }
        if (i == "May") {
            return "Tiếng Việt"
        }
        if (i == "June") {
            return "ភាសាខ្មែរ"
        }
        if (i == "July") {
            return "ລາວ"
        }
        if (i == "August") {
            return "Malaysia"
        }
        if (i == "September") {
            return "မြန်မာ"
        }
        if (i == "October") {
            return "Pilipinas"
        }
        if (i == "November") {
            return "한국인"
        }
    }
}
